import React from "react"
import NumerableIconButton from "../NumerableIconButton"
import { COLOR, JARGON, LINKS, LAYOUT } from "../../modules/constants"
import MenuIcon from "@mui/icons-material/Menu"
import BookOutlinedIcon from "@mui/icons-material/BookOutlined"

const tipEnabled = JARGON.EXTERNAL_LINK_TO + `Officer Appointments on Companies House service`
const label = "Companies House"

export default function CompaniesHousePersonMenu(props) {
    // console.log('CompaniesHousePersonMenu  props:', props)
    return (
        <div>
            {props.hubData.chIds.length > 1 && <NumerableIconButton item={getHeading(props)} />}
            {mapButtonProps(props)}
        </div>
    )
}

const getbuttonProps = props => {
    const { chIds, externalLinks, id, index } = props

    return (
        <NumerableIconButton key={index} item={{
            disabled: !externalLinks,
            tipEnabled,
            tipDisabled: tipEnabled + JARGON.SUBSCRIBED_USERS_ONLY,
            icon: <BookOutlinedIcon />,
            label: chIds.length > 1 ? `${label}: id ${index + 1}` : label,
            handleClick: () => {
                window.open(`${LINKS.COMPANIES_HOUSE}/officers/${id}/appointments`, "_blank")
            },
            paddingLeft: chIds.length > 1 ? LAYOUT.COLUMN_PADDING : null,
            fontWeight: "normal",
        }} />)
}

const getHeading = ({ externalLinks }) => {
    return {
        color: externalLinks ? COLOR.BRAND.STD : null,
        disabled: true,
        handleClick: () => { },
        icon: <MenuIcon />,
        label,
        fontWeight: "normal",
    }
}

const mapButtonProps = props => {
    // console.log('mapButtonProps props:', props);
    const { externalLinks, hubData } = props
    const { chIds } = hubData
    return chIds.map((id, index) => getbuttonProps({ chIds, externalLinks, id, index }))
}

